export default "__VITE_ASSET__BuD9Fgp5__"